import { HttpResponse } from "@angular/common/http";

/** True when duplicate-demande HTTP response indicates success. */
export function isDuplicateDemandeSuccess(res: HttpResponse<unknown>): boolean {
  if (!res) {
    return false;
  }
  const status = res.status ?? 0;
  return res.ok === true || (status >= 200 && status < 300);
}

/** Extract new demand id from duplicate API body (supports multiple backend shapes). */
export function extractDuplicatedDemandId(res: HttpResponse<unknown>): number | null {
  if (!isDuplicateDemandeSuccess(res)) {
    return null;
  }
  const body = res.body as Record<string, unknown> | null | undefined;
  if (!body) {
    return null;
  }

  const data = body["data"] as Record<string, unknown> | undefined;
  const demande = (body["demande"] ?? data?.["demande"]) as
    | Record<string, unknown>
    | undefined;

  const candidates: unknown[] = [
    demande?.["id"],
    body["demande_id"],
    body["demand_id"],
    data?.["demande_id"],
    data?.["demand_id"],
    data?.["id"],
    body["id"],
  ];

  if (typeof demande === "object" && demande !== null && "demande" in demande) {
    const nested = (demande as { demande?: { id?: unknown } }).demande?.id;
    candidates.unshift(nested);
  }

  for (const rawId of candidates) {
    if (rawId == null || rawId === "") {
      continue;
    }
    const id = Number(rawId);
    if (Number.isFinite(id) && id > 0) {
      return id;
    }
  }

  return null;
}
